import { DateFormatPipe } from './../../date-format.pipe';
import { ExpedientesService } from './../../services/expedientes.service';
import { AuthService } from './../../services/auth.service';
import { ClientesService } from './../../services/clientes.service';
import { UsuariosService } from './../../services/usuarios.service';
import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import 'rxjs/operators/map';
import 'rxjs/Rx';
import { saveAs } from 'file-saver/FileSaver';

@Component({
  selector: 'app-expediente',
  templateUrl: './expediente.component.html',
  styleUrls: ['./expediente.component.css']
})
export class ExpedienteComponent implements OnInit {
  
  @ViewChild("mensajeExpediente") mensaje: ElementRef;

  codigo;
  expediente={};
  adjuntos=[];
  intervinientes=[];
  actuaciones=[];
  provisiones=[];
  suplidos=[];
  pagado:boolean;

  constructor(private usuariosService:UsuariosService , private clientesService:ClientesService,
    private location: Location, private auth:AuthService, private expedientesService:ExpedientesService,
    private router:Router, private activatedRoute:ActivatedRoute, private renderer:Renderer2, 
    private dateFormat:DateFormatPipe) {
    
    this.cargarNombresClientes();
    this.cargarNombresUsuarios();
    this.activatedRoute.params.subscribe(params=>{
      this.codigo=params["cod"];
      if(this.codigo!="nuevo"){
        
        this.cargarExpediente();
          
        
      }else{
        this.expediente={};
        
        if(this.clientesService.clienteActual){
          this.expediente["EXcodcliente"]=this.clientesService.clienteActual["CLcodigo"];
        }

        this.adjuntos=[];
        this.intervinientes=[];
        this.actuaciones=[];
        this.provisiones=[];
        this.suplidos=[];
        this.expediente["EXpagado"]=0;
      }
      
    });
  }

  ngOnInit() {
  }

  cargarNombresClientes(){
    
    this.clientesService.getNombresClientes().subscribe();
  }

  cargarNombresUsuarios(){
    this.usuariosService.getNombresUsuarios().subscribe();
  }

  cargarExpediente(){
    this.expedientesService.getExpediente(this.codigo)
    .subscribe(resp=>{
      
      if(resp!=false){
        this.expediente=resp;
        this.expediente["EXfechaapertura"]=this.expediente["EXfechaapertura"].substring(0,10);
        if(this.expediente["EXfechacierre"]){
          this.expediente["EXfechacierre"]=this.expediente["EXfechacierre"].substring(0,10);
        }
        this.expediente["EXpagado"]==1?this.pagado=true:this.pagado=false;
        this.cargarAdjuntos();
        this.cargarIntervinientes();
        this.cargarActuaciones();
        this.cargarProvisiones();
        this.cargarSuplidos();

      }else{
        this.router.navigate(['/home']);
      }
    });
  }

//ADJUNTOS
  borrarAdjunto(codigoAdjunto){
    if(confirm("¿Desea borrar el documento adjunto seleccionado?")){
      this.expedientesService.borrarAdjunto(codigoAdjunto)
        .subscribe(resp=>{
        this.cargarAdjuntos();
      });
    }
    
  }

  cargarAdjuntos(){
    this.expedientesService.getAdjuntos(this.codigo)
    .subscribe(resp=>{
      this.adjuntos=resp;
    });
  }

  descargarAdjunto(i){
    this.expedientesService.descargarAdjunto(this.adjuntos[i])
    .subscribe(data=>saveAs(data, this.adjuntos[i].EDfichero)),
    error=> console.log("Error downloading"),
    ()=>console.log("Nice.");
  }
//INTERVINIENTES
  cargarIntervinientes(){
    this.expedientesService.getIntervinientes(this.codigo)
    .subscribe(resp=>{
      this.intervinientes=resp;
    })
  }
  borrarInterviniente(codInterviniente){
    if(confirm("¿Desea borrar el interviniente seleccionado de este expediente")){
      this.expedientesService.borrarInterviniente(codInterviniente).subscribe(resp=>{
        this.cargarIntervinientes();
      });
    }
    
  }

//ACTUACIONES

  cargarActuaciones(){
    this.expedientesService.getActuaciones(this.codigo)
    .subscribe(resp=>{
      this.actuaciones=resp;
    })
  }

  borrarActuacion(codigo){
    if(confirm("¿Desea borrar la actuacion que ha seleccionado?")){
      this.expedientesService.borrarActuacion(codigo)
      .subscribe(resp=>{
        this.cargarActuaciones();
      });
    }
  }

//PROVISIONES

  cargarProvisiones(){
    this.expedientesService.getProvisiones(this.codigo)
    .subscribe(resp=>{
      this.provisiones=resp;
    })
  }

  borrarProvision(codigo){
    if(confirm("¿Desea borrar la provisión seleccionada?")){
      this.expedientesService.borrarProvision(codigo)
      .subscribe(resp=>{
        this.cargarProvisiones();
      });
    }
  }

  descargarAdjuntoProvision(i){
    this.expedientesService.descargarAdjuntoProvision(this.provisiones[i])
    .subscribe(data=>saveAs(data, this.provisiones[i].EPficheroadjunto)),
    error=> console.log("Error downloading"),
    ()=>console.log("Nice.");
  }


//SUPLIDOS
  cargarSuplidos(){
    this.expedientesService.getSuplidos(this.codigo)
    .subscribe(resp=>{
      this.suplidos=resp;
    })
  }

  borrarSuplido(codigo){
    if(confirm("¿Desea borrar el suplido seleccionado?")){
      this.expedientesService.borrarSuplido(codigo)
      .subscribe(resp=>{
        this.cargarSuplidos();
      });
    }
  }

  descargarAdjuntoSuplido(i){
    this.expedientesService.descargarAdjuntoSuplido(this.suplidos[i])
    .subscribe(data=>saveAs(data, this.suplidos[i].ESficheroadjunto)),
    error=> console.log("Error downloading"),
    ()=>console.log("Nice.");
  }


//EXPEDIENTE

  guardarExpediente(){
    this.pagado==true?this.expediente["EXpagado"]=1:this.expediente["EXpagado"]=0;
    if(this.codigo=="nuevo"){
      this.insertExpediente();
    }else{
      this.updateExpediente();
    }
  }



  prepararNuevoExpediente(){
    this.clientesService.getCliente(this.expediente["EXcodcliente"])
    .subscribe(resp=>{
          this.expediente["EXnombre"]=resp["CLnombre"];
          this.expediente["EXemail"]=resp["CLemail"];
          this.expediente["EXtelefono"]=resp["CLtelefono"];
        });
        this.expediente["EXregistrado"]=1;
  }

  insertExpediente(){
    
    this.expedientesService.insertExpediente(this.expediente)
    .subscribe(resp=>{
      
      let texto=this.renderer.createText(resp["mensaje"]);
        if(resp["err"]==false){
          this.renderer.addClass(this.mensaje.nativeElement, "text-success");
        }else{
          this.renderer.addClass(this.mensaje.nativeElement, "text-danger");
        }

        this.renderer.appendChild(this.mensaje.nativeElement,texto);
        setTimeout(() => {
          this.renderer.removeChild(this.mensaje.nativeElement,texto);
          this.location.back();
        }, 2000);

    });
  }

  updateExpediente(){
    this.expedientesService.updateExpediente(this.expediente, this.expediente["EXcodigo"])
      .subscribe(resp=>{
        let texto=this.renderer.createText(resp["mensaje"]);
        if(resp["err"]==false){
          this.renderer.addClass(this.mensaje.nativeElement, "text-success");
        }else{
          this.renderer.addClass(this.mensaje.nativeElement, "text-danger");
        }

        this.renderer.appendChild(this.mensaje.nativeElement,texto);
        setTimeout(() => {
          this.renderer.removeChild(this.mensaje.nativeElement,texto);
        }, 2000);
      });
  }

  parseDate(dateString: string){
    if (dateString) {
      let fecha=new Date(dateString);
      var myDate_string = fecha.toISOString();
      var myDate_string = myDate_string.replace("T"," ");
      var myDate_string = myDate_string.substring(0,10);
        return myDate_string;
    } else {
        return null;
    }
  }
  
  volver(){
    this.location.back();
  }

  registrarClienteWeb(){
    if(confirm("¿Está seguro de querer dar de alta a este cliente web?")){
      this.clientesService.registrarClienteWeb(this.expediente)
      .subscribe(resp=>{
        setTimeout(() => {
          this.cargarNombresClientes();
          this.cargarExpediente();
        }, 1000);
      });
    }
  }


  imprimirMensaje(){
    let cierre="";
    if(this.expediente["EXfechacierre"]){
      cierre="F. cierre: "+this.dateFormat.transform(this.expediente["EXfechacierre"]);
    }

    var ventana = window.open('', 'PRINT', 'height=400,width=600');
    ventana.document.write('<html><head><title>' + document.title + '</title>');
    ventana.document.write('<style type="text/css" media="print">'
    +'@page '
    +'{'
        +'size: auto;'
        +'margin-top: 0mm;'
    +'}'
    +'</style>');
    ventana.document.write('</head><body>');
    ventana.document.write('<div id="divImprimir" style="margin-top: 50px;">'
    +'<img src="./assets/img/logo_solucion-legal.png" height="75px" style="margin:0 28%;" />'
    +'<h1 style="text-align:center">EXPEDIENTE</h1>'
    +'<div class="row">'
    +  '<span class="col-md-6 text-left my-1">Título: <b>'+this.expediente["EXtitulo"]+'</b></span>'
    +  '<span class="col-md-6 text-left my-1" style="float:right;">Nº Exp: <b>'+this.expediente["EXcodigo"]+'</b></span>'
    +'</div>'
    +'<div class="row pt-3" style="border-top: 1px solid rgb(138, 138, 138); padding-top:10px;">'
    +  '<span class="col-md-6 text-left" style="text-align:left;">Cliente: '+this.expediente["CLnombre"]+'</span>'
    +  '<span class="col-md-6 text-right" style="float:right;">F. apertura: '+this.dateFormat.transform(this.expediente["EXfechaapertura"])+'</span>'
    +'</div>'
    +'<div class="row pb-3" style="border-bottom:1px solid rgb(138,138,138); padding-bottom:10px">'
    +  '<small class="col-md-6 text-left" style="text-align:left;">Usuario:<b>'+this.expediente["USnombre"]+'</b></small>'
    +  '<span class="col-md-6 text-right" style="float:right;">'+cierre+'</span>'
    +'</div>'

    +'<div class="col-md-10 mx-auto my-3 p-2" style="border-top: 1px solid rgb(138, 138, 138);padding:5px; padding-top:15px;">'+this.expediente["EXdescripcion"]+'</div>');

    
    ventana.document.write('</body></html>');
    ventana.document.close();
    ventana.focus();
    ventana.onload = function() {
      ventana.print();
      ventana.close();
    };


  }
  
}



// WEBPACK FOOTER //
// ./src/app/components/expediente/expediente.component.ts